import { useCallback, useEffect, useState } from "react";
import { Link2, Copy, Lock, Trash2 } from "lucide-react";
import { api, errorMessage } from "../api";
import { KdsBoard } from "./KdsBoard";

function ScreenLink({ branch }) {
  const [token, setToken] = useState(null);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  useEffect(() => { api.get(`/kds/link?branch=${branch}`).then(({ data }) => setToken(data.token)).catch(() => {}); }, [branch]);
  const url = token ? `${window.location.origin}/kds/${token}` : "";
  const rotate = async () => { const { data } = await api.post(`/kds/link?branch=${branch}`); setToken(data.token); setMsg("New link created"); };
  const revoke = async () => { await api.delete(`/kds/link?branch=${branch}`); setToken(null); setMsg("Link revoked"); };
  const copy = async () => { try { await navigator.clipboard.writeText(url); setMsg("Copied"); } catch { setMsg("Copy failed — select and copy manually"); } };
  return (
    <div className="kds-link-wrap">
      <button onClick={() => setOpen(!open)} data-testid="kds-link-toggle"><Link2 size={15} /> TV / tablet link</button>
      {open && (
        <div className="kds-link-pop" data-testid="kds-link-panel">
          <p>Open this link on any kitchen TV or tablet — no login needed. Revoke it anytime.</p>
          {token ? <input readOnly value={url} onFocus={(e) => e.target.select()} data-testid="kds-link-url" /> : <em>No link yet.</em>}
          <div>
            {token && <button onClick={copy} data-testid="kds-link-copy"><Copy size={13} /> Copy</button>}
            <button onClick={rotate} data-testid="kds-link-generate">{token ? "Regenerate" : "Generate link"}</button>
            {token && <button onClick={revoke} data-testid="kds-link-revoke"><Trash2 size={13} /> Revoke</button>}
          </div>
          {msg && <small data-testid="kds-link-msg">{msg}</small>}
        </div>
      )}
    </div>
  );
}

export default function KitchenView({ branch, branchName, allowed, canLink, onUpgrade }) {
  const fetchBoard = useCallback(async (served) => (await api.get(`/kds?branch=${branch}&include_served=${served}`)).data, [branch]);
  const setKot = useCallback((id, status) => api.put(`/kds/kots/${id}/status?branch=${branch}`, { status }), [branch]);
  const setItem = useCallback((id, idx, status) => api.put(`/kds/kots/${id}/items/${idx}/status?branch=${branch}`, { status }), [branch]);
  if (!allowed) {
    return (
      <div className="panel kds-locked" data-testid="kds-locked">
        <Lock size={22} />
        <h2>Live Kitchen Display is a Professional feature</h2>
        <p>Run a self-refreshing KOT board on any kitchen TV or tablet, with late-order alerts.</p>
        <button className="primary-button" onClick={onUpgrade} data-testid="kds-upgrade-btn">See plans</button>
      </div>
    );
  }
  return <KdsBoard title="Kitchen Display" subtitle={branchName} fetchBoard={fetchBoard} setKot={setKot} setItem={setItem}
    onError={errorMessage} extra={canLink ? <ScreenLink branch={branch} /> : null} />;
}
